import { useAuth } from '../stores/auth';

const BASE = '/api/v1';

interface FetchOpts extends Omit<RequestInit, 'body'> {
  body?: unknown;
  raw?: boolean;
  /** Override the org context (platform-admin viewing a specific org); defaults to active org. */
  orgIdOverride?: string | null;
}

export async function api<T = unknown>(path: string, opts: FetchOpts = {}): Promise<T> {
  const { body, raw, headers, orgIdOverride, ...rest } = opts;
  const auth = useAuth.getState();
  const token = auth.token;
  const orgId = orgIdOverride === undefined ? auth.activeOrgId : orgIdOverride;
  const init: RequestInit = {
    ...rest,
    headers: {
      ...(body && !(body instanceof FormData) ? { 'content-type': 'application/json' } : {}),
      ...(token ? { authorization: `Bearer ${token}` } : {}),
      ...(orgId ? { 'x-org-id': orgId } : {}),
      ...(headers || {}),
    },
    body: body instanceof FormData ? body : body ? JSON.stringify(body) : undefined,
  };
  const res = await fetch(`${BASE}${path}`, init);
  if (res.status === 401) {
    useAuth.getState().logout();
  }
  if (!res.ok) {
    let detail: unknown;
    try { detail = await res.json(); } catch { /* */ }
    throw new ApiError(res.status, detail);
  }
  if (raw) return res as unknown as T;
  if (res.status === 204) return undefined as T;
  return res.json() as Promise<T>;
}

export class ApiError extends Error {
  constructor(public status: number, public detail: unknown) {
    super(`API ${status}`);
  }
}
